import React from "react";
import { Button } from "react-bootstrap";

function BorderedButton({ buttonText, onClickButton, isDisabled }) {
  return (
    <div className="commonBtnContainer">
      <Button
        variant="outline-danger"
        onClick={onClickButton}
        className={`${isDisabled ? "disabled" : ""}`}
      >
        {buttonText}
      </Button>
    </div>
  );
}

export default BorderedButton;
